import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { AbsenceApprovalStatusesEnum } from '@thinknet-gmbh/platform-common';

export const APPROVAL_STATUS_STYLES = {
  [AbsenceApprovalStatusesEnum.REJECTED]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
  [AbsenceApprovalStatusesEnum.APPROVED]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [AbsenceApprovalStatusesEnum.PENDING]: {
    background: PLATFORM_THEME_COLORS.tone.lightBlue,
    fontColor: PLATFORM_THEME_COLORS.primary.blue,
  },
};
